// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"64230d8b","977":"fa078835"}[chunkId] + ".chunk.js";
};